import { axios } from "../../../packs/axios";

export const passcodeAPI = {
  /**
   * Post Passcode for user
   * @constructor
   * @param {string} encodedID - The encoded ID.
   * @param {string} accessCode - The access code AKA pin ID.
   * @param {string} passcode - The passcode entered by the user.
   * @returns {object} {url: "http://..."} containing URL to redirect the user to
  **/
  postSetMemberPassword(encodedID, accessCode, passcode){
    return axios.post(`/set_member_password/${encodedID}?access_code=${accessCode}&password=${passcode}&password_confirmation=${passcode}`).then(resp => resp.data);
  },

  /**
   * Check user's existing passcode
   * @constructor
   * @param {string} encodedID - The encoded ID.
   * @param {number} passcode - The id of the user.
   * @param {boolean} rememberMe - The value of the "remember me" checkbox
   * @returns {object} {url: "http://..."} containing URL to redirect the user to
  **/
  getCheckMemberPasscode(encodedID, passcode, rememberMe){
    return axios.get(`/check_member_password/${encodedID}?password=${passcode}&remember_me=${rememberMe}`).then(resp => resp.data);
  },

  /**
   * Post a temporary pin code
   * @constructor
   * @param {string} encodedID - The encoded ID
   * @returns {object} {id: 1}
  **/
  postSendTempPin(encodedID){
    return axios.post(`/send_temp_pin/${encodedID}`).then(resp => resp.data);
  },

  /**
   * Check is the pin code is valid
   * @constructor
   * @param {string} encodedID - The pinID associated to the access code.
   * @param {string} tempPinCode - The temporary pin code entered by the user.
   * @returns {object} {status: HTTP_STATUS_OK}
  **/
  getCheckTempPin(encodedID, tempPinCode){
    return axios.get(`/check_temp_pin/${encodedID}?access_code=${tempPinCode}`).then(resp => resp);
  },

  /**
   * Check is member asked to be remembered
   * @constructor
   * @param {string} encodedID encodedID - The encoded ID
   * @returns {object} if user wants to be remembered it returns the stashboard content {sms_content: ...}
  **/
  getCheckRememberMe(encodedID){
    return axios.get(`/check_remember_me/${encodedID}`).then(resp => resp.data)
  }
}